import { render, staticRenderFns } from "./ThirdPartyServiceForm.vue?vue&type=template&id=52007ddd&"
import script from "./ThirdPartyServiceForm.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports